import { 
    createProduct, 
    getProductsByStoreId, 
    deleteProducts, 
    deleteAllproducts, 
    updateProduct, 
    searchProductsForStore,
    exportProductsByStore,
    importProducts
} from '../services/Api';

const create = async ( productData ) => {
    try {
        const response = await createProduct( productData );
        return response;
    } catch (err) {
        console.log("err to save product ", err)
        return null;
    }
};

const getProductsByStore = async ( storeId, page, limit ) => {
    try {
        const response = await getProductsByStoreId( storeId, page, limit );
        return response;
    } catch (err) {
        console.log("err to get products ", err)
        return null;
    }
};

const exportProducts = async ( storeIds ) => {
    try {
        const response = await exportProductsByStore( storeIds );
        return response;
    } catch (err) {
        console.log("err to export products ", err)
        return null;
    }
};

const importProductsFromDatabase = async ( importData ) => {
    try {
        const response = await importProducts( importData );
        return response;
    } catch (err) {
        console.log("err to import products ", err)
        return null;
    }
};

const searchProductsByStore = async ( storeId, query ) => {
    try {
        const response = await searchProductsForStore( storeId, query );
        return response;
    } catch (err) {
        console.log("err to get products ", err)
        return null;
    }
};

const deleteProductsFromDatabase = async ( productIds ) => {
    try {
        const response = await deleteProducts( productIds );
        return response;
    } catch (err) {
        console.log("err to delete product ", err)
        return null;
    }
};

const deleteAllProductsByStoreId = async ( productIds ) => {
    try {
        const response = await deleteAllproducts( productIds );
        return response;
    } catch (err) {
        console.log("err to delete product ", err)
        return null;
    }
};

const editProductFromDatabase = async ( productData ) => {
    try {
        const response = await updateProduct( productData );
        return response;
    } catch (err) {
        console.log("err to edit product ", err)
        return null;
    }
};

export {
    create,
    getProductsByStore,
    searchProductsByStore,
    exportProducts,
    importProductsFromDatabase,
    deleteProductsFromDatabase,
    deleteAllProductsByStoreId,
    editProductFromDatabase
 };